export { mockAssessments } from "./assessments";
export { mockQuickActions } from "./quick-actions";
export { mockLandingQuickStarts } from "./landing-quick-starts";
export { mockInsights } from "./insights";
export { mockInsightPanelSnapshot } from "./insights-panel";
export {
  getMockAssessmentDetail,
  getMockChatMessages,
  getMockInsightPanel,
} from "./session";
export type { MockAssessmentDetail } from "./session";
